export function sortArrayByLabel(data) {
  return data.sort((a, b) => {
    return a.label.localeCompare(b.label, "tr", { sensitivity: "variant", caseFirst: "upper" });
  });
}
